import React from 'react';
import styled from 'styled-components';
import Card from './Card';

type Props = {
    title?: string;
    children?: React.ReactNode;
};


const CardClose = (props: Props) => {
    const title = <TitleWrpperWidthStyled>
        <img className='title-icon' src="/img/icon/light-off-32x32.png" alt="" />
        {props.title}
    </TitleWrpperWidthStyled>

    return (
        <>
            <Card {...props} title={title} />
        </>
    );
};

const TitleWrpperWidthStyled = styled.div`
    margin: 0;
    & > .title-icon {
        position: relative;
        bottom: 2px;
        padding: 0 2px;
        margin-right: 8px;
        width: 26px;
    }
`

export default CardClose;